export default function TermsPage() {
  return (
    <div className="static-page">
      <h2>Terms of Service</h2>
      <p>
        By using TaskManager App, you agree to comply with our terms. You must be at least 13 years old to use this service. You are responsible for maintaining the confidentiality of your account credentials.
      </p>
      <p>
        We reserve the right to modify or discontinue any part of the service at any time. All tasks, reminders, and user-generated content remain your responsibility. Misuse of the platform may result in suspension or termination of your account.
      </p>
      <p>
        TaskManager App is provided “as is” without warranties of any kind. We are not liable for any data loss, missed reminders, or service interruptions.
      </p>
    </div>
  );
}